module.exports = __webpack_public_path__ + "static/course_record.15d2e119.png";